import { useEffect, useState } from "react";
import Dialog from "../../components/Dialog";

function fillValuesInCheckboxesArray(oldValues, indexesToBeChecked) {
  const newValues = [...oldValues];
  indexesToBeChecked.forEach(i => {
    newValues[i] = true;
  });
  return newValues;
}

function idsToIndexes(goals, ids = []) {
  return ids.map(id => goals.findIndex(goal => goal.id === id));
}

export default function MilestoneFormDialog(props) {
  const { isOpen, selectedMilestone, onClose, onSave, data } = props;
  const [goalMapping, setGoalMapping] = useState([]);
  const [newMilestoneFormData, setNewMilestoneFormData] = useState({
    name: "",
    description: "",
    dates: {
      starting: "",
      ending: "",
    }
  });

  useEffect(() => {
    setGoalMapping(fillValuesInCheckboxesArray(Array(data.goals.length).fill(false), idsToIndexes(data.goals, selectedMilestone?.epicGoals || [])));
  }, [data.goals, selectedMilestone]);

  return (
    <Dialog
      isOpen={isOpen}
      title={selectedMilestone ? `Milestone #${selectedMilestone?.id}` : "Create a new milestone"}
      onSave={() => onSave({
        ...newMilestoneFormData,
        ...selectedMilestone,
        epicGoals: goalMapping.map((isChecked, index) => isChecked ? (
          data.goals[index].id
        ) : null)
      })}
      setIsOpen={() => {
        onClose();
      }}
    >
      {selectedMilestone ? null : (
        <>
          <div className="flex-column m-b-md">
            <label>Name</label>
            <input value={newMilestoneFormData.name} onChange={(e) => setNewMilestoneFormData({
              ...newMilestoneFormData,
              name: e.target.value
            })}></input>
          </div>
          <div className="flex-column m-b-md">
            <label>Start date</label>
            <input type="date" value={newMilestoneFormData.dates.starting} onChange={(e) => setNewMilestoneFormData({
              ...newMilestoneFormData,
              dates: {
                ...newMilestoneFormData.dates,
                starting: e.target.value
              }
            })}></input>
          </div>
          <div className="flex-column m-b-md">
            <label>Start date</label>
            <input type="date" value={newMilestoneFormData.dates.ending} onChange={(e) => setNewMilestoneFormData({
              ...newMilestoneFormData,
              dates: {
                ...newMilestoneFormData.dates,
                ending: e.target.value
              }
            })}></input>
          </div>
        </>
      )}
      {selectedMilestone && (<div className="m-b-md">{selectedMilestone.name}</div>)}
      <strong>{selectedMilestone ? "Linked" : "Link"} Goals</strong>
      {data.goals.map((goal, index) => (
        <label className="flex-row flex-align-center pointer inline-block" key={index}>
          <input
            type="checkbox"
            checked={goalMapping[index]}
            onChange={(e) => {
              const newGoalMapping = [...goalMapping];
              newGoalMapping[index] = e.target.checked;
              setGoalMapping(newGoalMapping);
            }}
          ></input>
          <div>{goal.definition}</div>
        </label>
      ))}
    </Dialog>
  );
}